export { default as Tabs } from '@components/tabs/Tabs';


// WEBPACK FOOTER //
// ./src/components/tabs/index.ts